import { combineReducers } from 'redux';
import { INITIALIZE_COMPLETE, INITIALIZE_RESET } from '../actions/constants';
import navigation from './navigationReducer';
import masterData from './masterDataReducer';
import retailDashboard from './retailDashboardReducer';
import tripDashboard from './tripReducer';
import tripTracking from './tripTrackingReducer';
import cachedData from './cachedData';
import ltlTrackingReducer from './ltlTrackingReducer';
import carrierManagement  from './carrierManagementReducer';
import customerFeedbackReducer  from './customerFeedbackReducer';
import customerActivityShipmentViewReducer from './customerActivityShipmentViewReducer';
import invoice from './invoiceReducer';
import genericConsignmentReducer from './genericConsignmentReducer';
import FoodDashboardReducer from './FoodDashboardReducer';
import genericAnalyticsReducer from './genericAnalyticsReducer';
import generateReportsReducer from './generateReportsReducer';
import persistentIframe from './persistentIframeReducer';
import opsDashboardStateReducer from './opsDashboardStateReducer';
import opsDashboardManage from './opsDashboardManageReducer';
import riderTransactionHistory from './riderTransactionHistoryReducer';
import TMSDashboardReducer from './TMSDashboardReducer';
import TMSOverviewReducer from './TMSOverviewReducer';
import integrationMarketplace from './integrationMarketplace';
import genericPageReducer from './genericPageReducer';
import landingPageDashboardGroup from './landingPageDashboardGroupReducer';
import uiTheme from './themeReducer';
import reasonsDataReducer from './reasonsDataReducer';
import notificationReducer from './notificationReducer';
import liveDashboardReducer from '../components/pages/retail/dashboard/Live/LiveDashboard.reducer';
import valletTransactionsReducer from './ValletTransactionRoutes';
import financeUploadRequestsReducer from './FinanceUploadRequestsRoutes';
import podReviewReducer from '../components/pages/PodReview/PodReview.reducer';
import rosterManagementReducer from './RosterManagementReducer';
import shiftsTabReducer from './ShiftsTabReducer';
import pricingMasterReducer from './PricingMasterReducer';
import supportTicketsReducer from '../components/pages/SupportTickets/SupportTickets.reducer';
import jsonArrayTableViewReducer from './JsonArrayTableViewReducer';
import chatReducer from './chatReducer';
import analyticsContextReducer from './analyticsContextReducer';
import referralProgramReducer from '../components/pages/ReferralProgram/ReferralProgram.reducer';
import referrerConditionReducer from '../components/pages/ReferralProgram/ReferrerCondition.reducer';
import financeMasterDataReducer from './financeMasterDataReducer';
import receivablesMasterDataReducer from './receivablesMasterDataReducer'; 
import agentManagementReducer from './agentManagementReducer';

const initializing = function (state = true, action) {
 switch (action.type) {
   case INITIALIZE_COMPLETE:
     return false;
   case INITIALIZE_RESET:
     return true;


   default:
     return state;
 }
};


export default combineReducers({
  uiTheme,
  initializing,
  navigation,
  masterData,
  cachedData,
  retailDashboard,
  tripDashboard,
  tripTracking,
  ltlTrackingReducer,
  carrierManagement,
  customerFeedbackReducer,
  customerActivityShipmentViewReducer,
  invoice,
  genericConsignmentReducer,
  FoodDashboardReducer,
  genericAnalyticsReducer,
  generateReportsReducer,
  persistentIframe,
  opsDashboardManage,
  riderTransactionHistory,
  TMSDashboardReducer,
  TMSOverviewReducer,
  opsDashboardStateReducer,
  integrationMarketplace,
  genericPageReducer,
  landingPageDashboardGroup,
  notificationReducer,
  liveDashboardReducer,
  reasonsDataReducer,
  valletTransactionsReducer,
  financeUploadRequestsReducer,
  podReviewReducer,
  rosterManagementReducer,
  shiftsTabReducer,
  pricingMasterReducer,
  supportTicketsReducer,
  jsonArrayTableViewReducer,
  chat: chatReducer,
  analyticsContext: analyticsContextReducer,
  referralProgram: referralProgramReducer,
  referrerCondition: referrerConditionReducer,
  financeMasterData: financeMasterDataReducer,
  receivablesMasterData: receivablesMasterDataReducer,
  agentManagement: agentManagementReducer,
});
